import GeneralClientCreateForm from './GeneralClientCreateForm'
import GeneralClientEditForm from './GeneralClientEditForm'

function GeneralStep({ mode, setSetupMode }) {
  return (
    <>
      {mode === 'create' && <GeneralClientCreateForm setSetupMode={setSetupMode} />}
      {mode === 'edit' && <GeneralClientEditForm />}
    </>
  )
}

export default GeneralStep
